import { type SxProps, Typography, type TypographyProps } from '@mui/material';
import type { ReactNode } from 'react';

type TitleSize = 'lg' | 'md' | 'sm' | 'xs';

// Map sizes to theme typography variants
const variantMap: Record<TitleSize, TypographyProps['variant']> = {
  lg: 'h2', // 24px, 600 weight - Page titles
  md: 'h4', // 18px, 500 weight - Section headers
  sm: 'h5', // 16px, 500 weight - Subsections
  xs: 'h6', // 14px, 600 weight - Small headers
};

interface Props {
  children: ReactNode;
  size: TitleSize;
  sx?: SxProps;
  component?: any;
  id?: string;
}

export default function Title({ id, children, size, component, sx }: Props) {
  return (
    <Typography
      variant={variantMap[size]}
      sx={sx}
      component={component}
      id={id}
    >
      {children}
    </Typography>
  );
}
